import React from 'react'
import { withStyles } from '@material-ui/core'
import { Pagination, PaginationItem } from '@material-ui/lab'
import {
	darkBlue,
	primaryB,
	primaryC,
	secondaryB
} from 'asterX-UIkit/constants/colors'

const styles = {
	root: {},
	rootItem: {},
	selected: {
		backgroundColor: primaryB + '!important',
		color: primaryC + '!important'
	},
	page: {
		fontSize: 16,
		fontWeight: 600,
		color: darkBlue
	},
	arrow: {
		right: 0,
		width: 50,
		height: 50,
		borderRadius: 50,
		backgroundColor: secondaryB + '!important',
		color: darkBlue
	}
}
const AsterPagination = withStyles(styles)(({ classes, color, ...other }) => (
	<Pagination
		className={classes.root}
		{...other}
		renderItem={item => (
			<PaginationItem
				{...item}
				classes={{
					selected: classes.selected,
					page:
						item.type === 'next' || item.type === 'previous'
							? classes.arrow
							: classes.page
				}}
			/>
		)}
	/>
))

export default AsterPagination
